import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/luggages";

const getBaggages = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const createBaggages = async (baggage: any) => {
  try {
    const response = await axios.post(API_URL, baggage);
    if (response.status === 201) {
      return {
        success: true,
        message: "Baggage details created successfully",
      };
    }
  } catch (error) {
    console.log("create baggage error " + error);
    return { success: false, message: handleError(error) };
  }
};

const updateBaggage = async (id: number, baggage: any) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, baggage);
    if (response.status === 200) {
      return {
        success: true,
        message: "Baggage details updated successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const deleteBaggage = async (id: number) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    if (response.status === 200) {
      return {
        success: true,
        message: "Baggage details deleted successfully",
      };
    }
  } catch (error) {
    return { success: false, message: handleError(error) };
  }
};

const handleError = (error: any) => {
  if (axios.isAxiosError(error)) {
    if (!error.response) {
      return "Network error. Please check your internet connection.";
    } else {
      return `Error: ${error.response.status} - ${error.response.data}`;
    }
  } else {
    return "An unexpected error occurred:";
  }
};

export { getBaggages, createBaggages, updateBaggage, deleteBaggage };
